// src/pages/Supply.tsx — SUPPLY (Oct 29, 2026, record 100; 00044 v2.4). Top-level page, next to Orders.
// Where Green Maestro delivers local materials: one category in one market, switched on by hand when a real supplier deal
// exists. Filter by ZIP or see every switch. Paid jobs to order from show on Orders ("Contractor jobs: materials to order").
import { useState } from "react";
import { Link } from "react-router-dom";
import { PageFrame } from "../components/ui";
import { SupplyPanel } from "../components/SupplyPanel";

const isZip = (z: string) => /^\d{5}$/.test(z.trim());

export default function Supply() {
  const [zip, setZip] = useState("");
  const [shown, setShown] = useState<string | null>(null);
  return (
    <PageFrame
      title="Supply"
      lede={
        <>
          Where Green Maestro delivers local materials to contractors' jobs — one category in one market, turned on when a real
          supplier deal exists. Paid jobs to order from are on <Link to="/orders">Orders</Link>.
        </>
      }
    >
      <form
        className="zip-search"
        onSubmit={(e) => {
          e.preventDefault();
          if (isZip(zip)) setShown(zip.trim());
        }}
      >
        <input
          type="search"
          className="search"
          inputMode="numeric"
          placeholder="Show one ZIP, e.g. 98223"
          value={zip}
          onChange={(e) => setZip(e.target.value)}
          aria-label="ZIP code"
        />
        <button type="submit" className="btn" disabled={!isZip(zip)}>
          Show ZIP
        </button>
        {shown && (
          <button
            type="button"
            className="btn quiet"
            onClick={() => {
              setZip("");
              setShown(null);
            }}
          >
            Show every ZIP
          </button>
        )}
      </form>
      <SupplyPanel zip={shown} />
    </PageFrame>
  );
}
